import { buildModuleRoutePermissionMap } from './moduleMenus';

const baseRoutePermissionMap = {
  '/dashboard': 'oa:dashboard',
  '/portal': 'oa:portal',
  '/approval-center': 'oa:approval:center',
  '/plan/personal': 'oa:plan:board:personal',
  '/plan/dept': 'oa:plan:board:dept',
  '/plan/company': 'oa:plan:board:company',
  '/plan/major-issue': 'oa:plan:major:issue',
  '/plan/report/dept': 'oa:plan:report:dept',
  '/plan/report/company': 'oa:plan:report:company',
  '/system/users': 'oa:system:user',
  '/system/roles': 'oa:system:role',
  '/system/operation-logs': 'oa:system:log',
  '/system/workflows': 'oa:system:workflow',
  '/system/onboarding-form-config': 'oa:system:onboarding-form-config',
  '/system/ops-board': 'oa:system:ops-board'
};

export const routePermissionMap = {
  ...baseRoutePermissionMap,
  ...buildModuleRoutePermissionMap()
};

export const getPermissionByRoute = (routePath) => routePermissionMap[routePath] || null;
